// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3Oxrb","upload":"Small_upload__kYOuW","imageWrap":"Small_imageWrap__3Hg6g","removeBtn":"Small_removeBtn__1cVbX"};